import * as React from 'react';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

import MenuItem from '@mui/material/MenuItem';

import { DataGrid } from '@mui/x-data-grid';

import { getPayers } from '../../../../services/api/apiManager';

import { useState, useEffect } from 'react';

import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

import Tooltip from '@mui/material/Tooltip';

import IconButton from '@mui/material/IconButton';

import DialogTitle from '@mui/material/DialogTitle';

import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import { useTheme } from '@mui/material/styles';

import { updatePayer } from '../../../../services/api/apiManager';

import CancelIcon from '@mui/icons-material/Cancel';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import * as Yup from 'yup';

import {
	Alert,
	Box,
	Button,
	CircularProgress,
	Grid,
	Input,
	InputLabel,
	Modal,
	Snackbar,
	Typography,
	useMediaQuery,
	TextField,
	InputAdornment,
	Select,
} from '@mui/material';
import { Call } from '@mui/icons-material';
import MaskedInput from 'react-text-mask';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '55%',
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	borderRadius: '12px',
};

function Viewpayer() {
	// Edit Delete Popover states and functions are here
	const [anchorED, setAnchorED] = React.useState(null);
	const editDelete_pop_opens = Boolean(anchorED);
	const handleClick = (event, params) => {
		// i am opening my popover from here and also setting values of modals from here am setting delete and edit modal states data from here

		setModalValues(params?.row);

		//setting deleteModal Data
		setDeleteUser(params?.row?.Name);
		setDeleteID(params?.row?.id);

		setAnchorED(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorED(null);
	};

	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const [payers, setPayers] = useState([]);

	const [openModal, setOpenModal] = useState(false);

	// Delete Data States
	const [deleteID, setDeleteID] = useState();
	const [deleteUser, setDeleteUser] = useState();
	// Loader State
	const [loading, setLoading] = useState(false);
	// Dialog State
	const theme = useTheme();
	const [dialogOpen, setDialogOpen] = React.useState(false);
	const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

	// Function -- Edit Payer
	const [modalValues, setModalValues] = useState([]);

	// Close Modal
	const handleCloseModal = () => {
		setOpenModal(false);
	};

	const schema = Yup.object().shape({
		Name: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		// City: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		// State: Yup.string().matches(/^[a-zA-Z]+$/, 'Alphabets only'),
		// Contact: Yup.string().matches(
		// 	/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
		// 	'Invalid '
		// ),
		// Zip: Yup.string().matches(
		// 	/^\+?1?\(?\d{3}\)?[-\s]*\d{2}[-\s]*\d{4}$|^\+?\d+$/,
		// 	'Invalid '
		// ),
	});

	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setModalValues((prev) => ({
			...prev,
			[name]: value,
		}));
		if (name === 'Name') {
			Yup.reach(schema, name)
				.validate(value)
				.then(() => {
					setErrors((prevErrors) => ({
						...prevErrors,
						[name]: '', // Clear error if validation passes
					}));
				})
				.catch((error) => {
					setErrors((prevErrors) => ({
						...prevErrors,
						[name]: error.message, // Set error message if validation fails
					}));
				});
		}
	};

	// Snackbar States
	const [severity, setSeverity] = useState('success'); // Default severity
	const [openSnackbar, setOpenSnackbar] = useState(false);
	// open snakbar
	const handleClickSnackbar = () => {
		setOpenSnackbar(true);
	};
	//   close Snackbar
	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	// Fetch Api Payer Data
	const fetchPayers = async () => {
		setLoading(true);
		try {
			// debugger;
			const response = await getPayers();

			if (response?.status === 200) {
				setLoading(false);
				setPayers(response?.data?.reverse());
			} else {
				setPayers([]);
			}
		} catch (error) {
			console.error('Error fetching payers:', error);
		}
	};

	// Calling API Data
	useEffect(() => {
		fetchPayers();
	}, []);

	// Function -- Target Modal Textfields Values
	const targetModalValue = (event) => {
		event.preventDefault();
		setModalValues({
			...modalValues,
			[event.target.name]: event.target.value,
		});
	};

	// // Function -- Edit Payer Data
	const handleEdit = () => {
		// Open the Modal
		setOpenModal(true);
	};

	// Function -- Edit Payer Data
	// Function -- Update Payer Data
	const updateModalValues = async (modalValues) => {
		if (
			errors?.Name ||
			errors?.City ||
			errors?.Contact ||
			errors?.State ||
			errors?.Zip
		) {
		} else {
			setLoading(true);
			const resp = await updatePayer(modalValues.id, modalValues);
			setAnchorED(null);
			if (resp?.request?.status === 200) {
				// Update, Then Close Modal
				handleCloseModal();
				// Open Snackbar Alert
				handleClickSnackbar('success');
				setSeverity('updated');
				setLoading(false);
				fetchPayers();

				// // Snackbar Color Show
				// try {
				// 	const newData = await fetchPayers();
				// 	setLoading(false);
				// 	// console.log(newData);
				// } catch (error) {
				// 	console.error('Error fetching data:', error);
				// }
			}
		}
	};

	const handleDialogClose = () => {
		setDialogOpen(false);
	};

	const deleteCancelPopup = () => {
		setDeletePopupOpen(false);
	};

	const handleDialogOpen = () => {
		setDialogOpen(true);
	};

	// Function -- Set open Delete PopUp-Modal
	const handleDelete = () => {
		setDeletePopupOpen(true);
	};

	// Handle Delete Status Data
	const deleteStatus = {
		Deleted: true,
	};

	// Function -- Delete Data
	const deletePayer = async (deleteID) => {
		const response = await updatePayer(deleteID, deleteStatus);
		setLoading(true);

		if (response?.request?.status === 200) {
			setSeverity('success');
			setDeletePopupOpen(false);
			setLoading(false);
			handleClickSnackbar('error');
			try {
				const newData = await fetchPayers();
				setLoading(false);
				// console.log(newData);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setDeletePopupOpen(false);
			// setLoading(false);
		}
		setAnchorED(null);
	};

	// Data Grid Rows Data
	const rows =
		payers &&
		payers?.map((p, index) => ({
			// payerId: index,
			id: p?.id,
			Name: p?.Name || '',
			Type: p?.Type || '',
			Contact: p?.Contact || '',
			Address: p?.Address || '',
			Comments: p?.Comments || '',
			City: p?.City || '',
			State: p?.State || '',
			Zip: p?.Zip || '',
		}));

	const columns = [
		// { field: 'payerId', headerName: 'Index', width: 80 },
		// { field: 'id', headerName: 'Id', width: 80 },
		{ field: 'Name', headerName: 'Name', width: 200 },
		{ field: 'Type', headerName: 'Type', width: 200 },
		{ field: 'Contact', headerName: 'Contact', width: 200 },
		{ field: 'Address', headerName: 'Address', width: 352 },
		{ field: 'Comments', headerName: 'Comments', width: 245 },
		// { field: 'City', headerName: 'City', width: 130, },
		// { field: 'State', headerName: 'State', width: 130, },
		// { field: 'Zip', headerName: 'Zip', width: 100, },
		{
			sortable: false,
			disableColumnMenu: true,
			field: 'action',
			headerName: 'Action',
			description: 'This column has a value getter and is not sortable.',
			sortable: false,

			minWidth: 100,
			renderCell: (params) => {
				return (
					<div>
						<IconButton
							aria-label="more"
							id="long-button"
							aria-controls={editDelete_pop_opens ? 'long-menu' : undefined}
							aria-expanded={editDelete_pop_opens ? 'true' : undefined}
							aria-haspopup="true"
							onClick={(event) => {
								handleClick(event, params);
							}}
						>
							<MoreVertIcon />
						</IconButton>
						<Menu
							sx={{ marginTop: '-1.5%' }}
							id="long-menu"
							anchorEl={anchorED}
							open={editDelete_pop_opens}
							onClose={handleClose}
							PaperProps={{
								style: {
									width: '83px',
									width: '72px',
									borderRadius: '7px',
									boxShadow: '0px 1px 10px 0px #00000040',
								},
							}}
						>
							<MenuItem onClick={() => handleEdit()} sx={{ fontSize: '14px' }}>
								Edit
							</MenuItem>
							<MenuItem
								onClick={() => handleDelete()}
								sx={{ fontSize: '14px', color: '#ED2828' }}
							>
								Delete
							</MenuItem>
						</Menu>
					</div>
					// <IconButton style={{ fontSize: '1.2rem' }}>
					// 	<Tooltip title="Edit User">
					// 		<BorderColorOutlinedIcon
					// 			fontSize="small"
					// 			style={{ marginLeft: 5, cursor: 'pointer', color: 'black' }}
					// 			onClick={() => handleEdit(params)}
					// 		/>
					// 	</Tooltip>
					// 	<Tooltip title="Delete User">
					// 		<DeleteOutlinedIcon
					// 			fontSize="small"
					// 			style={{ marginLeft: 5, cursor: 'pointer', color: 'black' }}
					// 			onClick={() => handleDelete(params)}
					// 		/>
					// 	</Tooltip>
					// </IconButton>
				);
			},
		},
	];
	// const handleClick = (event) => {
	// 	setAnchorEl(event.currentTarget);
	// };
	// const handleClose = () => {
	// 	setAnchorEl(null);
	// };

	// const [page, setPage] = React.useState(0);
	// const [rowsPerPage, setRowsPerPage] = React.useState(8);

	// const handleChangePage = (event, newPage) => {
	// 	setPage(newPage);
	// };

	// const handleChangeRowsPerPage = (event) => {
	// 	setRowsPerPage(+event.target.value);
	// 	setPage(0);
	// };

	return (
		<div>
			{!loading && payers?.length === 0 ? (
				<Box
					width={'100%'}
					height={'45vh'}
					display={'flex'}
					alignItems={'center'}
					justifyContent={'center'}
					color={'#ED2828'}
				>
					Add payer to proceed !
				</Box>
			) : (
				''
			)}

			{loading ? (
				<Box
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						// height: '100vh',
					}}
				>
					<CircularProgress />
				</Box>
			) : (
				<Box
					sx={{
						overflow: 'auto',
						height: '70vh',
						width: {
							xl: '100%',
							lg: '90%',
							md: '80%',
							sm: '80%',
							xs: '70%',
						},
					}}
				>
					{payers?.length > 0 && (
						<DataGrid
							rows={rows}
							rowHeight={38}
							columnHeaderHeight={38}
							columns={columns}
							fontFamily={'Poppins'}
							initialState={{
								pagination: { paginationModel: { pageSize: 10 } },
							}}
							pageSizeOptions={[10, 25, 50]}
							// checkboxSelection
							disableRowSelectionOnClick
							sx={{
								'& .MuiDataGrid-columnHeaders': {
									// backgroundColor: '#DCF0FFBA',
									background: '#EEF5FFCC',
									color: '#333',
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '15px',
								},
								'& .MuiDataGrid-footerContainer': {
									justifyContent: 'flex-end',
									backgroundColor: '#DCF0FFBA',
								},
							}}
						/>
					)}

					{/* Modal Structure */}
					<Modal
						open={openModal}
						// onClose={handleCloseModal} // Close Modal When any screen click.
						aria-labelledby="edit-modal-title"
						aria-describedby="edit-modal-description"
						sx={{
							'& .MuiModal-backdrop': {
								opacity: '0.75 !important',
							},
						}}
					>
						<Box sx={style}>
							<Grid
								item
								lg={12}
								xs={12}
								md={12}
								sm={12}
								xl={12}
								justifyContent="center"
							>
								<Box
									sx={{
										width: '100%',
										height: '65px',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										borderBottom: '1px solid #00000070',
									}}
								>
									<Typography
										sx={{
											width: '88%',
											fontFamily: 'Poppins',
											fontSize: '32px',
											fontWeight: 500,
											textAlign: 'center',
										}}
									>
										Edit Payer
									</Typography>
									<IconButton onClick={handleCloseModal}>
										<CancelIcon sx={{ fontSize: '30px' }} color="error" />
									</IconButton>
								</Box>
							</Grid>
							<Grid container lg={12} xs={12} md={12} sm={12} p={3}>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Payer Name<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										// value={location?.Name}
										// onChange={(e) =>
										// 	setLocation((prev) => ({ ...prev, Name: e.target.value }))
										// }
										name="Name"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Name}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Name && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Name}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Payer Type<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<Select
										name="Type"
										size="small"
										fullWidth
										displayEmpty
										inputProps={{ padding: '2px' }}
										value={modalValues?.Type}
										onChange={targetModalValue}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									>
										<MenuItem value={'private'}>Private</MenuItem>
										<MenuItem value={'government'}>Government</MenuItem>
									</Select>
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Contact
										{/* <span style={{ color: '#d61b1b' }}>*</span> */}
									</InputLabel>
									<MaskedInput
										required
										name="Contact"
										value={modalValues?.Contact}
										onChange={handleInputChange}
										mask={[
											'(',
											/\d/,
											/\d/,
											/\d/,
											')',
											' ',
											/\d/,
											/\d/,
											/\d/,
											'-',
											/\d/,
											/\d/,
											/\d/,
											/\d/,
										]}
										style={{
											width: '100%',
											borderRadius: '6px',
											height: '40px',
											marginBottom: '8px',
											// marginTop: '8px',
											border: '1.5px solid #DDE6F1',
											padding: '5px 0px 5px 6px',

											outlineColor: '#f3a765',
											boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
										}}
									/>
									{errors.Contact && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Contact}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={12}
									xs={12}
									md={12}
									sm={12}
									xl={12}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Address
									</InputLabel>
									<TextField
										// value={location?.Address}
										// onChange={(e) =>
										// 	setLocation((prev) => ({
										// 		...prev,
										// 		Address: e.target.value,
										// 	}))
										// }
										name="Address"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Address}
										onChange={targetModalValue}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									xl={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										City
										{/* <span style={{ color: '#d61b1b' }}>*</span> */}
									</InputLabel>
									<TextField
										// value={location?.City}
										// onChange={(e) =>
										// 	setLocation((prev) => ({ ...prev, City: e.target.value }))
										// }
										name="City"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues.City}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.City && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.City}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									xl={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										State
										{/* <span style={{ color: '#d61b1b' }}>*</span> */}
									</InputLabel>
									<TextField
										// value={location?.State}
										// onChange={(e) =>
										// 	setLocation((prev) => ({
										// 		...prev,
										// 		State: e.target.value,
										// 	}))
										// }
										name="State"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues.State}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.State && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.State}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									xl={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										ZIP
										{/* <span style={{ color: '#d61b1b' }}>*</span> */}
									</InputLabel>
									<TextField
										// value={location?.Zip}
										// onChange={(e) =>
										// 	setLocation((prev) => ({ ...prev, Zip: e.target.value }))
										// }
										name="Zip"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues.Zip}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Zip && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Zip}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={12}
									xs={12}
									md={12}
									sm={12}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Comments
									</InputLabel>
									<TextField
										// value={location?.Type}
										// onChange={(e) =>
										// 	setLocation((prev) => ({ ...prev, Type: e.target.value }))
										// }
										name="Comments"
										type="text"
										fullWidth
										disableUnderline
										value={modalValues?.Comments}
										onChange={targetModalValue}
										sx={{
											'& input': {
												height: '23px',
											},
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
								</Grid>
							</Grid>
							<Box
								mt={1}
								width={'100%'}
								height={'70px'}
								display={'flex'}
								justifyContent={'center'}
								gap={2}
							>
								<Button
									onClick={handleCloseModal}
									style={{
										backgroundColor: '#ED2828',
										width: '151px',
										height: '52px',
										borderRadius: '7px',
										color: '#FFFFFF',
										fontSize: '20px',
									}}
								>
									Cancel
								</Button>
								<Button
									disabled={
										errors?.Name
										// || errors?.City
										//|| errors?.Contact ||
										// errors?.State ||
										// errors?.Zip
									}
									style={{
										backgroundColor: `${errors?.Name ? 'grey' : '#00A2E8'}`,
										// backgroundColor: `${errors?.Name || errors?.City || errors?.Contact || errors?.State || errors?.Zip ? 'grey' : '#00A2E8'}`,
										width: '151px',
										height: '52px',
										borderRadius: '7px',
										color: '#FFFFFF',
										fontSize: '20px',
									}}
									onClick={() => updateModalValues(modalValues)}
								>
									Update
								</Button>
							</Box>
						</Box>
					</Modal>

					{/*Delete Dialog Structure */}

					<Dialog
						// fullScreen={fullScreen}
						open={deletePopupOpen}
						onClose={handleDialogClose}
						aria-labelledby="responsive-dialog-title"
						PaperProps={{
							style: { borderRadius: 8, width: '50%' },
						}}
					>
						<DialogTitle
							id="responsive-dialog-title"
							sx={{
								width: '100%',
								height: '80px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderBottom: '1px solid #00000070',
							}}
						>
							<Typography
								width={'85%'}
								textAlign="center"
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '32px',
								}}
							>
								{' '}
								Delete Payer{' '}
							</Typography>

							<IconButton
								sx={{ width: '5%' }}
								size="small"
								onClick={deleteCancelPopup}
							>
								<CancelIcon color="error" sx={{ fontSize: '30px' }} />
							</IconButton>
						</DialogTitle>
						<DialogContent>
							<Typography
								textAlign="center"
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '25px',
									color: 'black',
								}}
							>
								{' '}
								Are you sure to delete this Payer?{' '}
							</Typography>
							<Typography
								textAlign="center"
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '25px',
									color: '#075AD7',
								}}
							>
								{deleteUser}
							</Typography>
							<br />
							<Grid container spacing={2} align="center">
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
									<Button
										style={{
											backgroundColor: '#ED2828',
											width: '151px',
											height: '52px',
											borderRadius: '7px',
											color: '#FFFFFF',
											fontSize: '20px',
										}}
										onClick={deleteCancelPopup}
									>
										No
									</Button>
								</Grid>
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
									<Button
										style={{
											backgroundColor: '#00A2E8',
											width: '151px',
											height: '52px',
											borderRadius: '7px',
											color: '#FFFFFF',
											fontSize: '20px',
										}}
										onClick={() => {
											deletePayer(deleteID, deleteStatus);
										}}
									>
										Yes
									</Button>
								</Grid>
							</Grid>
						</DialogContent>
					</Dialog>

					{/* Show Snackbar After Deletion */}

					<Snackbar
						open={openSnackbar}
						onClose={handleCloseSnackbar}
						autoHideDuration={1500}
						anchorOrigin={{
							vertical: 'center',
							horizontal: 'center',
						}}
					>
						<Alert
							onClose={handleCloseSnackbar}
							// severity="error"
							severity="success"
							variant="filled"
							sx={{
								width: '100%',
								textAlign: 'center',
								fontSize: '13px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							action={
								<React.Fragment>
									<span
										onClick={() => {
											handleCloseSnackbar();
										}}
										style={{
											cursor: 'pointer',
											m: 'auto 0',
											fontSize: '13px',
											color: 'rgb(231, 231, 231)',
										}}
									>
										Close
									</span>
								</React.Fragment>
							}
						>
							{severity === 'success'
								? 'Payer Deleted Successfully !'
								: 'Payer Updated Successfully !'}
						</Alert>
					</Snackbar>
				</Box>
			)}
		</div>
	);
}

export default Viewpayer;
